export * from './InlinedSvg';
